import PropTypes from 'prop-types';

const SchoolYearType = PropTypes.shape({
  id: PropTypes.string,
  name: PropTypes.string
});

export default SchoolYearType;
